
















































import Vue from "vue";
import { PuzzleListItem } from "vue/types/vue";
import { PuzzleService } from "../../services/puzzleservice";
export default Vue.extend({
  name: "UserPuzzleItem",
  props: {
    puzzle: {
      type: Object as () => PuzzleListItem,
      default: {} as () => PuzzleListItem,
    },
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    deletePuzzle: function (puzzleName: string, puzzleid: string): void {
      this.$emit("deletePuzzle", { name: puzzleName, id: puzzleid });
    },
  },
});
